export class AutoReminderRule {
  id: number;
  intranet_id: number;
  matter_id: number;
  matter_user_type_id: number;
  duration_after: number = 0;
  created_by: any;
  updated_by: any;
  created_at: any;
  updated_at: any;
  topic: string;
  body: string;
  document_types_str: string;
  matter_user_type_name: string;
  matter_full_name: string;
  document_type_ids: Array<number> = [];
  send_email_after_duration: number;
  send_text_after_duration: number;
  send_to_users_included_in_all_notifications: boolean = false;
}
